// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3qM9Y","sendOtp":"AuthorizeToLogin_sendOtp__1uXhD"};